module.exports = __webpack_public_path__ + "img/feedback.35e8945d.png";